import { render, staticRenderFns } from "./DropCourseOperations.vue?vue&type=template&id=cb08e0d4"
import script from "./DropCourseOperations.vue?vue&type=script&lang=ts"
export * from "./DropCourseOperations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports